import script from "./TransactionsModals.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionsModals.vue?vue&type=script&setup=true&lang=js"

import "./TransactionsModals.vue?vue&type=style&index=0&id=7b97d125&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b97d125"]])

export default __exports__